module.exports = __webpack_public_path__ + "static/DSC_9408-fcbc478a8c405d0be74d901295b1ac64.jpg";